import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";
import { StepRow } from "@/components/mongo/MongoSteps";

const STATUSES = ["", "ok", "refused", "withheld", "error"];

export default function McpAuditPanel() {
    const [items, setItems] = useState(null);
    const [status, setStatus] = useState("");
    const load = useCallback(async () => {
        try { setItems((await api.get(`/admin/mongo-mcp/audit?limit=50${status ? `&status=${status}` : ""}`)).data.items || []); }
        catch (e) { toast.error(formatApiErrorDetail(e)); }
    }, [status]);
    useEffect(() => { load(); }, [load]);
    return (
        <div className="bg-[#0a0a0a] border border-white/10 rounded-md" data-testid="mcp-audit-card">
            <div className="flex items-center gap-2 px-5 py-4 border-b border-white/10">
                <ScrollText className="w-4 h-4 text-white/60" strokeWidth={1.5} />
                <div className="font-display text-lg tracking-tight flex-1">Tool-call audit</div>
                <span className="text-[11px] text-white/40 mr-2">Query and lock only — never the returned data</span>
                <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="mcp-audit-status"
                    className="bg-[#050505] border border-white/10 rounded px-2 py-1 text-[11px]">
                    {STATUSES.map((s) => <option key={s} value={s}>{s || "all"}</option>)}
                </select>
            </div>
            <div className="p-4 space-y-1.5 max-h-[480px] overflow-auto" data-testid="mcp-audit-list">
                {items === null ? <div className="text-xs text-white/40">Loading…</div> : items.length === 0 ? (
                    <div className="text-xs text-white/40" data-testid="mcp-audit-empty">No tool calls yet.</div>
                ) : items.map((a, i) => (
                    <div key={a.id}>
                        <div className="text-[10px] font-mono text-white/35 px-1 pb-0.5">
                            {new Date(a.at).toLocaleString()} · {a.actor?.email || a.actor?.kind || "system"} · {a.kind}{a.agent_id ? ` ${a.agent_id.slice(0, 8)}` : ""}{a.chat_id ? ` ${a.chat_id.slice(0, 8)}` : ""}
                        </div>
                        <StepRow index={`audit-${i}`} step={{ ...a, lock: a.lock?.label, lock_field: a.lock?.field }} />
                    </div>
                ))}
            </div>
        </div>
    );
}
